import {TimeScale} from '../../../../../../types';
import {Thresholds} from './types';

export const timeRangeWarningThresholds: Thresholds = {
    [TimeScale.LIVE]: null,
    [TimeScale.HOURLY]: [3, 'days'],
    [TimeScale.DAILY]: [1, 'month'],
    [TimeScale.WEEKLY]: [2, 'months'],
    [TimeScale.MONTHLY]: [6, 'months']
};
